var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-main"},[_c('div',[_c('p',[_vm._v(" 404 ")]),_c('p',[_vm._v(" 該当のページが存在しません。 ")]),_c('button',{on:{"click":_vm.event}},[_vm._v(" トップに戻る ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }